import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

export class ZIDXAccountCMAReportsRefineSearch implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCMAReportsRefineSearchContainer";
    }
    render(){
        // console.log("cma-reports/refine-search");
    }
}